import { useQuery } from "@tanstack/react-query";
import {
  Archive,
  Boxes,
  ClipboardCheck,
  Clock3,
  FileUp,
  RefreshCw,
} from "lucide-react";
import { api } from "../api";
import { Button, EmptyState, Panel } from "../components/ui";
import { PageHeader } from "../components/shell";
import { formatNumber } from "../numbers";
import type { Dashboard } from "../types";

const cards = [
  {
    key: "activeBoms",
    label: "BOM đang áp dụng",
    icon: ClipboardCheck,
    color: "blue",
  },
  { key: "draftBoms", label: "Bản nháp", icon: FileUp, color: "orange" },
  {
    key: "waitingApproval",
    label: "Chờ phê duyệt",
    icon: Clock3,
    color: "violet",
  },
  {
    key: "materials",
    label: "Vật tư đang quản lý",
    icon: Boxes,
    color: "green",
  },
] as const;

export function DashboardPage({
  onNavigate,
}: {
  onNavigate(route: "boms"): void;
}) {
  const dashboard = useQuery({
    queryKey: ["dashboard"],
    queryFn: () => api<Dashboard>("/dashboard"),
  });
  const data = dashboard.data;
  return (
    <div className="page">
      <PageHeader
        title="Tổng quan"
        actions={
          <Button variant="outline" onClick={() => dashboard.refetch()}>
            <RefreshCw size={16} /> Làm mới
          </Button>
        }
      />
      <div className="stats-grid">
        {cards.map(({ key, label, icon: Icon, color }) => (
          <Panel key={key} className={`stat-card ${color}`}>
            <div>
              <span>{label}</span>
              <strong>{data?.[key] === undefined ? "—" : formatNumber(data[key])}</strong>
            </div>
            <Icon size={25} />
          </Panel>
        ))}
      </div>
      <div className="overview-grid">
        <Panel title="BOM cần theo dõi">
          <EmptyState
            title="Chưa có BOM nào cần xử lý"
            detail="Các bản nháp và yêu cầu phê duyệt sẽ xuất hiện tại đây."
            action={
              <Button onClick={() => onNavigate("boms")}>Quản lý BOM</Button>
            }
          />
        </Panel>
        <Panel title="Tiến trình nhập dữ liệu">
          <div className="overview-import">
            <Archive size={30} />
            <div>
              <strong>{formatNumber(data?.runningImports ?? 0)} phiên đang xử lý</strong>
              <p>Các tệp XLSX được kiểm tra và xử lý theo nhóm BOM.</p>
            </div>
            <Button variant="outline" onClick={() => onNavigate("boms")}>
              Mở quản lý BOM
            </Button>
          </div>
        </Panel>
      </div>
    </div>
  );
}
